import React from "react";
import { Box } from "@mui/material";
import HeroSection from "../components/sections/HeroSection";
import ContactSection from "../components/sections/ContactSection";
import ResultsSection from "../components/sections/ResultsSection";
import HighlightSection from "../components/sections/HighlightSection";
import HowWeHelpSection from "../components/sections/HowWeHelpSection";
import ClientLogosSection from "../components/sections/CientLogosSection";
import WhyChooseUsSection from "../components/sections/WhyChooseUsSection";
import WhoWeHelpSection from "../components/sections/WhoWeHelpSection";
import FAQSection from "../components/sections/FAQSection";
import TestimonialsSection from "../components/sections/TestimonialsSection";

const HomePage: React.FC = () => {
  return (
    <Box component="main">
      <HeroSection />
      <HowWeHelpSection />
      <TestimonialsSection />
      <WhoWeHelpSection />
      <ResultsSection />
      <WhyChooseUsSection />
      <ClientLogosSection />
      <HighlightSection />
      <FAQSection />
      <ContactSection />
    </Box>
  );
};

export default HomePage;
